import {css} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {makeNavbarBackgroundStyles} from 'nav/navbar/NavBarColor';
import ClickOutWrapper from 'ui-library/ClickOutWrapper';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import * as SidepanelActions from '../sidepanel/SidepanelActions';
import {getIconStyles, navBarIconStyles} from './NavBarIcon';

export interface CreateIconProps {
  createMenu: React.ReactNode;
  isCreateMenuOpen: boolean;
}

class CreateIcon extends React.Component<CreateIconProps> {
  _handleToggleCreateMenu = (): void => {
    if (this.props.isCreateMenuOpen) {
      SidepanelActions.closeCreateMenu();
    } else {
      SidepanelActions.openCreateMenu();
    }
  };

  _handleCloseCreateMenu = (): void => {
    if (this.props.isCreateMenuOpen) {
      SidepanelActions.closeCreateMenu();
    }
  };

  render(): JSX.Element {
    const itemStyles = getIconStyles(this.props.isCreateMenuOpen);
    return (
      <ClickOutWrapper shouldCloseOnInsideClick={false} onClickOut={this._handleCloseCreateMenu}>
        <Tooltip isDisabled={this.props.isCreateMenuOpen} placement={FloatingPlacement.RIGHT} text="Create">
          <div
            className={classNames(css(itemStyles), this.props.isCreateMenuOpen && 'open')}
            style={makeNavbarBackgroundStyles(false)}
          >
            <div
              className={classNames(css(navBarIconStyles.inner), '_test-createIcon-inner')}
              onClick={this._handleToggleCreateMenu}
            >
              <BenchlingIcon icon="compose" className={css(navBarIconStyles.icon)} />
            </div>
            <div
              onClick={this._handleCloseCreateMenu}
              className={classNames(this.props.isCreateMenuOpen && 'open')}
            >
              {this.props.createMenu}
            </div>
          </div>
        </Tooltip>
      </ClickOutWrapper>
    );
  }
}

export default CreateIcon;
